import { SkeletonBar } from '@euler/app/components/task-card/components/SkeletonBar';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { memo } from 'react';
import { View } from 'react-native';

/** A placeholder's grey: just off the white list, a step above `bg.sunken`. */
const kSkeletonColor = '#EAEDF2';

/**
 * One placeholder row in `ThreadRow`'s shape (the category's square icon,
 * the title with its time, a subtitle, the two-line preview), so the swap
 * to real rows does not move anything. `wide` varies
 * the bars' lengths from row to row.
 */
export const FeedThreadRowSkeleton = memo(({ wide }: { wide: boolean }) => {
  const { rpx } = useResponsiveContext();
  return (
    <View
      style={{
        flexDirection: 'row',
        alignItems: 'flex-start',
        paddingVertical: rpx(14),
        paddingHorizontal: rpx(16),
      }}
    >
      <View
        style={{
          width: rpx(42),
          height: rpx(42),
          borderRadius: rpx(12),
          marginRight: rpx(12),
          backgroundColor: kSkeletonColor,
        }}
      />
      <View style={{ flex: 1, gap: rpx(8), paddingTop: rpx(2) }}>
        <View
          style={{
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'space-between',
          }}
        >
          <SkeletonBar
            width={rpx(wide ? 120 : 88)}
            height={rpx(14)}
            color={kSkeletonColor}
          />
          <SkeletonBar
            width={rpx(36)}
            height={rpx(10)}
            color={kSkeletonColor}
          />
        </View>
        <SkeletonBar
          width={rpx(wide ? 220 : 180)}
          height={rpx(12)}
          color={kSkeletonColor}
        />
        <SkeletonBar
          width={rpx(wide ? 150 : 200)}
          height={rpx(12)}
          color={kSkeletonColor}
        />
      </View>
    </View>
  );
});
